import sortBy from 'lodash/sortBy';
import moment from 'moment';

export const sortByDateAscending = (items) =>
  sortBy(items, (item) => moment(item.fileStatusDate)).reverse();

export default sortByDateAscending;
